import { Stack } from '@mantine/core';

import { CollapsableArticle } from '@/module/AnnualReport/items/collapsable/CollapsableArticle';
import { CollapsableIsiArticle } from '@/module/AnnualReport/items/collapsable/CollapsableIsiArticle';
import { CollapsableProceeding } from '@/module/AnnualReport/items/collapsable/CollapsableProceedings';
import { AnnualReportArticles } from '@/module/AnnualReport/model/AnnualReportTypes';

interface AnnualArticlesOverviewProps {
  articles: AnnualReportArticles;
}

export function AnnualArticlesOverview({ articles }: AnnualArticlesOverviewProps) {
  return (
    <Stack gap="xl">
      <CollapsableIsiArticle
        title="Articole in extenso, publicate în reviste cotate ISI,  CU factor de impact"
        articles={articles.isiWithFiArticles}
      />
      <CollapsableIsiArticle
        title="Articole in extenso, publicate  în reviste cotate ISI, FĂRĂ factor de impact"
        articles={articles.isiWithoutFiArticles}
      />
      <CollapsableArticle
        title="Articole tip proceedings papers, in extenso, publicate în reviste cotate ISI"
        articles={articles.isiArticlesProceedings}
      />
      <CollapsableProceeding
        title="Articole tip proceedings papers, in extenso, publicate în volume de proceedings cotate ISI"
        proceedings={articles.isiVolumesProceedings}
      />
      <CollapsableProceeding
        title="Articole in extenso publicate în reviste / volume indexate BDI"
        proceedings={articles.bdiProceedings}
      />

      <CollapsableArticle
        title="Articole in extenso publicate în reviste / volume indexate BDI"
        articles={articles.bdiArticles}
      />
      <CollapsableArticle
        title="Articole in extenso publicate în reviste recunoscute de CNCS, categoria B"
        articles={articles.cncsArticles}
      />
    </Stack>
  );
}
